/*
 * code for /scentiva/ page
 */

import { gsap, ScrollTrigger } from 'gsap/all';

// switch scents
$('.scentiva-scent-toggle').click(() => {
    // update nav itself
    $('.scentiva-scent-explore').toggleClass('active');
    $('.scentiva-scent-toggle').toggleClass('active');
});

// video handling
//  on click, toggle full window size & muted
const videoClickHandler = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const y = e.clientY - rect.top;
    const height = rect.bottom - rect.top;

    // don't handle clicks in video controls area...
    //  about 75px from bottom
    if (height - y < 75 / window.devicePixelRatio) {
        return null;
    }

    e.preventDefault();
    e.stopPropagation();

    const vid = e.currentTarget;
    vid.muted = !vid.muted;

    // add class to resize video
    vid.classList.toggle('expanded');
    $('.scentiva-hero').toggleClass('video-expanded');

    return false;
};
const vids = document.getElementsByClassName('scentiva-video');
for (let i = 0; i < vids.length; i += 1) {
    vids[i].addEventListener('click', videoClickHandler, true);
    vids[i].addEventListener('touchend', videoClickHandler, true);
}

// tile images
$('.lazy-product-tile').Lazy();

// gsap animation
gsap.registerPlugin(ScrollTrigger);
// nav bar -> fade in/out
ScrollTrigger.create({
    trigger: '.animation-panel-lavender',
    endTrigger: '.animation-panel-grapefruit',
    start: 'top-=350px bottom',
    end: 'bottom+=400px bottom',
    // onToggle: (self) => console.log("toggled", self.isActive),
    // markers: true,
    toggleClass: { targets: '#animation-nav', className: 'active' },
});

// nav bar active state

// make blossom active
gsap.fromTo(
    '.animation-nav-selector',
    {
        y: -5,
        scrollTrigger: {
            trigger: '.animation-panel-blossom',
            endTrigger: '.animation-panel-blossom',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'none none reverse none',
        },
    },
    {
        y: 115,
        scrollTrigger: {
            trigger: '.animation-panel-blossom',
            endTrigger: '.animation-panel-blossom',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'play none reverse none',
        },
    }
);

// make red-sea active
gsap.fromTo(
    '.animation-nav-selector',
    {
        y: 115,
        scrollTrigger: {
            trigger: '.animation-panel-red-sea',
            endTrigger: '.animation-panel-red-sea',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'none none reverse none',
        },
    },
    {
        y: 235,
        scrollTrigger: {
            trigger: '.animation-panel-red-sea',
            endTrigger: '.animation-panel-red-sea',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'play none reverse none',
        },
    }
);

// make grapefruit active
gsap.fromTo(
    '.animation-nav-selector',
    {
        y: 235,
        scrollTrigger: {
            trigger: '.animation-panel-grapefruit',
            endTrigger: '.animation-panel-grapefruit',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'none none reverse none',
        },
    },
    {
        y: 355,
        scrollTrigger: {
            trigger: '.animation-panel-grapefruit',
            endTrigger: '.animation-panel-grapefruit',
            start: 'top-=150px center',
            end: 'top-=100px center',
            // markers: true,
            toggleActions: 'play none reverse none',
        },
    }
);

// bg change (#ECDBEB, #C9E8F9, #FAE2D4)

// fade to lavender
gsap.to('.scentiva-animation-bg-lavender', {
    opacity: 1,
    scrollTrigger: {
        trigger: '.animation-panel-lavender',
        endTrigger: '.animation-panel-lavender',
        start: 'top-=350px bottom',
        end: 'top-=50px bottom',
        scrub: true,
        // markers: true,
    },
});

// fade to blue
gsap.to('.scentiva-animation-bg-blossom', {
    opacity: 1,
    scrollTrigger: {
        trigger: '.animation-panel-blossom',
        endTrigger: '.animation-panel-blossom',
        start: 'top-=250px center',
        end: 'top-=50px center',
        scrub: true,
        // markers: true,
    },
});

// fade to red-sea
gsap.to('.scentiva-animation-bg-red-sea', {
    opacity: 1,
    scrollTrigger: {
        trigger: '.animation-panel-red-sea',
        endTrigger: '.animation-panel-red-sea',
        start: 'top-=250px center',
        end: 'top-=1px center',
        scrub: true,
        // markers: true
    },
});

// fade to grapefruit
gsap.to('.scentiva-animation-bg-grapefruit', {
    opacity: 1,
    scrollTrigger: {
        trigger: '.animation-panel-grapefruit',
        endTrigger: '.animation-panel-grapefruit',
        start: 'top-=250px center',
        end: 'top-=1px center',
        scrub: true,
        // markers: true
    },
});

// lavender sprinkles (mobile)
gsap.to('.sprinkle-lavender-mobile-1 img', {
    y: -91,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-mobile-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-mobile-2 img', {
    y: -217,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-mobile-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-mobile-3 img', {
    y: -239,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-mobile-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-mobile-4 img', {
    y: -90,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-mobile-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-mobile-5 img', {
    y: -57,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-mobile-5 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// blossom sprinkles (mobile)
gsap.to('.sprinkle-blossom-mobile-1 img', {
    y: -164,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-mobile-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-mobile-2 img', {
    y: -233,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-mobile-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-mobile-3 img', {
    y: -48,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-mobile-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-mobile-4 img', {
    y: -188,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-mobile-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// red-sea sprinkles (mobile)
gsap.to('.sprinkle-red-sea-mobile-1 img', {
    y: -246,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-mobile-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-mobile-2 img', {
    y: -136,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-mobile-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-mobile-3 img', {
    y: -107,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-mobile-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-mobile-4 img', {
    y: -97,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-mobile-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// grapefruit sprinkles (mobile)
gsap.to('.sprinkle-grapefruit-mobile-1 img', {
    y: -246,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-mobile-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-mobile-2 img', {
    y: -136,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-mobile-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-mobile-3 img', {
    y: -107,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-mobile-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-mobile-4 img', {
    y: -97,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-mobile-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// lavender sprinkles (desktop)
gsap.to('.sprinkle-lavender-desktop-1 img', {
    y: -160,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-desktop-2 img', {
    y: -180,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-desktop-3 img', {
    y: -30,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-desktop-4 img', {
    y: -140,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-desktop-5 img', {
    y: -40,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-5 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-lavender-desktop-6 img', {
    y: -40,
    scrollTrigger: {
        trigger: '.sprinkle-lavender-desktop-6 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// blossom sprinkles (desktop)
gsap.to('.sprinkle-blossom-desktop-1 img', {
    y: -214,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-2 img', {
    y: -160,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-2-2 img', {
    y: 0,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-2-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-2-3 img', {
    y: -60,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-2-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-3 img', {
    y: -160,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-4 img', {
    y: -135,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-4-2 img', {
    y: -60,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-4-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-blossom-desktop-5 img', {
    y: -135,
    scrollTrigger: {
        trigger: '.sprinkle-blossom-desktop-5 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// red-sea sprinkles (desktop)
gsap.to('.sprinkle-red-sea-desktop-1 img', {
    y: -120,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-2 img', {
    y: -20,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-3 img', {
    y: -30,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-4 img', {
    y: -90,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-5 img', {
    y: -160,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-5 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-6 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-6 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-7 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-7 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-8 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-8 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-8 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-8 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-9 img', {
    y: -40,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-9 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-10 img', {
    y: -50,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-10 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-red-sea-desktop-11 img', {
    y: -80,
    scrollTrigger: {
        trigger: '.sprinkle-red-sea-desktop-11 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});

// grapefruit sprinkles (desktop)
gsap.to('.sprinkle-grapefruit-desktop-1 img', {
    y: -120,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-1 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-2 img', {
    y: -20,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-2 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-3 img', {
    y: -30,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-3 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-4 img', {
    y: -90,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-4 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-5 img', {
    y: -160,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-5 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-6 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-6 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-7 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-7 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
gsap.to('.sprinkle-grapefruit-desktop-8 img', {
    y: -99,
    scrollTrigger: {
        trigger: '.sprinkle-grapefruit-desktop-8 img',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true
    },
});
